import { SurveyData } from '@dev/ee-modules';
import { AccountSurveyPayload, AccountSurveyType } from '@dev/ee-api/ee-api-models';
import {
    OnboardingSurveyActionTypes,
    OnboardingSurveyState,
    SaveOnboardingSurveyErrorAction,
    SaveOnboardingSurveyStartAction,
    SaveOnboardingSurveySuccessAction,
    LoadOnboardingSurveyStartAction,
    LoadOnboardingSurveySuccessAction,
    LoadOnboardingSurveyErrorAction,
} from './types';
import { ApplicationState } from '..';

export const SaveOnboardingSurveyStart = (payload: SurveyData): SaveOnboardingSurveyStartAction => ({
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_START,
    payload,
});

export const SaveOnboardingSurveySuccess = (): SaveOnboardingSurveySuccessAction => ({
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_SUCCESS,
});

export const SaveOnboardingSurveyError = (): SaveOnboardingSurveyErrorAction => ({
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_ERROR,
});

export const LoadOnboardingSurveyStart = (type?: AccountSurveyType): LoadOnboardingSurveyStartAction => ({
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_START,
    payload: {
        type,
    },
});

export const LoadOnboardingSurveySuccess = (payload: AccountSurveyPayload): LoadOnboardingSurveySuccessAction => ({
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_SUCCESS,
    payload,
});

export const LoadOnboardingSurveyError = (): LoadOnboardingSurveyErrorAction => ({
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_ERROR,
});

export const getOnboardingSurveyStore = (store: ApplicationState): OnboardingSurveyState => store?.onboardingSurvey;
